import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

const styles = {
  Pending: "bg-yellow-100 text-yellow-800 border-yellow-200",
  Assigned: "bg-blue-100 text-blue-800 border-blue-200",
  "In Progress": "bg-violet-100 text-violet-800 border-violet-200",
  Ready: "bg-emerald-100 text-emerald-800 border-emerald-200",
  Delivered: "bg-zinc-900 text-white border-zinc-900",
};

const priorityStyles = {
  Low: "bg-zinc-100 text-zinc-700 border-zinc-200",
  Medium: "bg-amber-100 text-amber-800 border-amber-200",
  High: "bg-red-100 text-red-800 border-red-200",
};

export function StatusBadge({ status }) {
  return (
    <Badge
      variant="outline"
      className={cn("rounded-full text-[11px] tracking-wide font-medium uppercase px-2.5 py-0.5", styles[status])}
      data-testid={`status-badge-${status}`}
    >
      {status}
    </Badge>
  );
}

export function PriorityBadge({ priority }) {
  return (
    <Badge
      variant="outline"
      className={cn("rounded-full text-[11px] tracking-wide font-medium uppercase px-2.5 py-0.5", priorityStyles[priority])}
    >
      {priority}
    </Badge>
  );
}
